import {toast } from "react-toastify";
const showToastMessage = (message: string, type: "error" | "success") => {
    if (type === "error") { 
        toast.error(message, {
            position: "top-center",
        });
    }
    if(type === "success") {
        toast.success(message, {
            position: "top-center",
        });
    }
};
export default showToastMessage;